import React from 'react';

import {labels as utilLabels} from '../../../../../../../util/utils';

import OutputText from '@ey/canvascoreservices/OutputText';

import Tooltip from '../../../../../../CoreWrappers/Tooltip';
import RiskTypeAbbreviationDisplay from '../../../../../RiskTypeAbbreviationDisplay';
import StyledRiskDetailsName from './StyledRiskDetailsName';

export const prop = 'componentTeamRiskName';

export const config = (labels) => ({
	id: 'componentTeamRiskNameColumn',
	label: labels.regionComponentTeamRiskName,
	propName: prop,
	sortBy: ['riskTypeId', 'riskName'],
	width: '1fr',
	customCell: (item) => {
		const renderName = (className = '') => {
			return (
				<StyledRiskDetailsName>
					<RiskTypeAbbreviationDisplay id={item.riskTypeId} className={className} />
					{item.riskName && (
						<OutputText body2 ellipsis multilineEllipsis={2} title={item.riskName} className={className}>
							{item.riskName}
						</OutputText>
					)}
				</StyledRiskDetailsName>
			);
		};

		if (item.disabled) {
			const renderTrigger = () => {
				return renderName('disabled-risk');
			};

			const toolTipProps = {
				trigger: renderTrigger(),
				allowClick: true,
				placement: 'top'
			};

			return (
				<Tooltip {...toolTipProps}>
					<OutputText body2 light maxWidth="var(--px-700)" wordBreak>
						{utilLabels.disabledRegionComponentTeamRiskLabel}
					</OutputText>
				</Tooltip>
			);
		}

		return renderName();
	}
});
